﻿import * as eventTypes from '../../../map/utils/eventTypes';
import * as layerTypes from '../../../map/utils/layerTypes';
import * as geomTypes from '../../../map/utils/geomTypes';
import Draw, { createBox } from 'ol/interaction/Draw';
import {
    Fill,
    RegularShape,
    Stroke,
    Style,
    Text,
} from 'ol/style.js';
import { primaryAction } from 'ol/events/condition';
import { LineString, Point } from 'ol/geom.js';
import { measureArea, measureCircleArea, measureLength } from '../../../map/utils/utils';

export default class SelectionToolbarControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, snapOpts) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.map = mapControl.map;
        this.currentInteraction = null;
        this.layerAdded = false;
        this.additionalSettingsVisible = false;
        this.multipleSelectionId = 'multiple-selection-id-' + this.classId;

        this.toolbarActions = [
            { action: "selection-point", active: true, icon: "fal fa-crosshairs", title: this.resourcesHandler.get("SelectByPoint"), handler: this._getSelectByPointHandler(), options: null },
            { action: "selection-circle", icon: "fal fa-circle", title: this.resourcesHandler.get("SelectByCircle"), handler: this._getSelectByCircleHandler(), options: null },
            { action: "selection-line", icon: "ni ni-graph", title: this.resourcesHandler.get("SelectByLine"), handler: this._getSelectByLineHandler(), options: null },
            { action: "selection-rectangle", icon: "fal fa-square", title: this.resourcesHandler.get("SelectByRectangle"), handler: this._getSelectByRectangleHandler(), options: null },
            { action: "selection-polygon", icon: "fal fa-draw-polygon", title: this.resourcesHandler.get("SelectByPolygon"), handler: this._getSelectByPolygonHandler(), options: null },
            { action: "selection-selected", icon: "fal fa-hand-pointer", title: this.resourcesHandler.get("SelectBySelected"), handler: this._getSelectBySelectedHandler(), options: null, disabled: true },
            { action: "selection-options", icon: "fal fa-cog", title: this.resourcesHandler.get("SelectionOptions"), handler: this._getSelectionOptionsHandler(), options: null },
            { action: "clear-selection", icon: "fal fa-times", title: this.resourcesHandler.get("ClearSelection"), handler: this._getClearSelectionHandler(), options: null, display: 'none' }
        ];
    }

    init() {
        if (this._isMobileDevice()) return;

        if (!this.layerAdded) {
            this._addSelectionLayer();
        }

        if ($('.map-serach-config').length > 0) {
            $('.map-serach-config').addClass('map-search-joined');
        }

        this._initDrawStyle();
        $event.register(eventTypes.DRAW_TOOLBAR_VISIBLE, this._getDrawToolbarVisibleHandler(), this, this.classId);
        $event.register(eventTypes.DRAW_TOOLBAR_HIDDEN, this._getDrawToolbarHiddenHandler(), this, this.classId);
        $event.register(eventTypes.RIGHT_CLICK, this._getUserMapRightClickHandler(), this, this.classId);
        $event.register(eventTypes.FEATURE_SELECTION_CHANGED, this._getFeatureSelectionChangedHandler(), this, this.classId);

        let selectedItems = $(this.menuContainer).find(".map-toolbar-selected-items");
        $('<ul class="map-toolbar-selection-list"></ul>').insertBefore(selectedItems);
        $(`<ul class="map-toolbar-selection-options" style="display: none;">
            <li class="toolbar-selection-option">
                <div class="col-12 mb-0 align-content-start custom-map-switch" style="padding-top: 0.5rem; padding-bottom: 0.2rem;">
                    <div class="form-group" style="display: flex; flex-direction: row-reverse; height: 1.2rem; justify-content: flex-end;">
                        <label class="form-label ml-3">` + this.resourcesHandler.get('MultipleSelection') + `</label>
                        <div id="` + this.multipleSelectionId + `"></div>
                    </div>
                </div>
            </li>
        </ul>`).insertBefore(selectedItems);

        for (var i = 0; i < this.toolbarActions.length; i++) {
            $(this.menuContainer).find(".map-toolbar-selection-list").append('<li' + (this.toolbarActions[i].display != null ? (' style="display:' + this.toolbarActions[i].display + ';"') : '') + ' class="map-toolbar-item header-icon ' + this.toolbarActions[i].action + ' ' + (this.toolbarActions[i].active ? 'active' : '') + (this.toolbarActions[i].disabled ? ' disabled' : '') + '" title="' + this.resourcesHandler.get(this.toolbarActions[i].title)
                + '"><i class="' + this.toolbarActions[i].icon + '" style="font-size: 1rem !important;"></i></li>');
            if (this.toolbarActions[i].options == null && this.toolbarActions[i].handler != null) {
                $(this.menuContainer).find("." + this.toolbarActions[i].action).click(this.toolbarActions[i].handler);
            }
            else if (this.toolbarActions[i].options != null && this.toolbarActions[i].options.length > 0) {
                $(this.menuContainer).find("." + this.toolbarActions[i].action).attr("data-toggle", "dropdown");
                $(this.menuContainer).find("." + this.toolbarActions[i].action).append('<div class="dropdown-menu"></div>');
                for (var j = 0; j < this.toolbarActions[i].options.length; j++) {
                    $(this.menuContainer).find("." + this.toolbarActions[i].action).find(".dropdown-menu").append(
                        '<a class="dropdown-item" data-action="' + this.toolbarActions[i].options[j].action + '" href="javascript:void(0)">' + this.toolbarActions[i].options[j].title + '</a>'
                    );
                    $(this.menuContainer).find("." + this.toolbarActions[i].action).find(".dropdown-item[data-action='" + this.toolbarActions[i].options[j].action + "']").click(this.toolbarActions[i].options[j].handler);
                }
            }
        }

        $('#' + this.multipleSelectionId).kendoSwitch({
            messages: {
                checked: '',
                unchecked: ''
            },
            checked: this.mapControl.generalSettingsHandler.settings.AllowMultipleSelection,
            change: (evt) => {
                this.mapControl.selectionHandler.selectionHolder.allowMultiple = evt.sender.check();
            }
        });

        $(this.menuContainer).find(".toolbar-selection").show();
    }

    _isMobileDevice() {
        let supportsTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints) && (window.innerWidth < 750);
        return supportsTouch;
    }

    _drawStyleFunction(feature, drawType) {
        let styles = [];
        let geometry = feature.getGeometry();
        let type = geometry.getType();
        let point, label, line, circleLine, pointLabel;
        if (!drawType || drawType === type || type === 'Point') {
            let allStyle = this.drawMeasureStyle.clone();
            if (drawType == 'Circle' || drawType == 'Polygon') {
                allStyle.getFill().setColor('rgba(255, 255, 255, 0.4)');
            }

            if (type != 'Point') {
                styles.push(allStyle);
            }

            if (type === 'Polygon') {
                point = geometry.getInteriorPoint();
                label = this._formatArea(feature, geometry);
                if (geometry.getCoordinates()[0].length > 2) {
                    line = new LineString([geometry.getCoordinates()[0][geometry.getCoordinates()[0].length - 3], geometry.getCoordinates()[0][geometry.getCoordinates()[0].length - 2]]);
                }
            } else if (type === 'LineString') {
                point = new Point(geometry.getLastCoordinate());
                label = this._formatLength(feature, this._measureLength(geometry));
                pointLabel = this._formatCoordinates(feature, point);
                line = geometry;
            } else if (drawType == 'Circle' && type != 'Point') {
                point = new Point(geometry.getCenter());
                label = this._formatCircleArea(feature, geometry);

                let secondPoint = geometry.getCenter();
                secondPoint[0] += geometry.getRadius();
                circleLine = new LineString([geometry.getCenter(), secondPoint]);
            } else if (drawType == 'Point' || (type == 'Point' && drawType != 'Point')) {
                point = new Point(geometry.getCoordinates());
                label = this._formatCoordinates(feature, geometry);
            }
        }

        let lastSegmentAngle;
        let perimeterLabel;
        let perimeter;
        let cursorPoint;

        if (line) {
            line.forEachSegment((a, b) => {
                let segment = new LineString([a, b]);
                let angle = this._formatAngle(feature, segment);
                lastSegmentAngle = this.drawLabelStyle.clone();
                cursorPoint = new Point(segment.getLastCoordinate());
                lastSegmentAngle.setGeometry(cursorPoint);
                lastSegmentAngle.getText().setText(angle);

                if (type == 'Polygon') {
                    lastSegmentAngle.getText().setOffsetY(27);
                } else {
                    lastSegmentAngle.getText().setOffsetY(40);
                }
            });
        }

        if (type == 'Polygon') {
            let points = feature.getGeometry().getCoordinates()[0];
            perimeter = 0;

            for (let i = 1; i < points.length; i++) {
                let segment = new LineString([points[i - 1], points[i]]);
                perimeter += this._measureLength(segment);

                perimeterLabel = this.drawLabelStyle.clone();
                perimeterLabel.setGeometry(geometry.getInteriorPoint());
                perimeterLabel.getText().setText(this._formatLength(feature, perimeter));
                perimeterLabel.getText().setOffsetY(10);
            }
        }

        if (label) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(label);

            if (pointLabel) {
                clone.getText().setOffsetY(27);
            }

            styles.push(clone);
        }

        if (pointLabel) {
            let clone = this.drawLabelStyle.clone();
            clone.setGeometry(point);
            clone.getText().setText(pointLabel);

            styles.push(clone);
        }

        if (lastSegmentAngle) {
            styles.push(lastSegmentAngle);
        }

        if (perimeterLabel) {
            styles.push(perimeterLabel);
        }

        return styles;
    }

    _formatCoordinates(feature, geometry) {
        let coordinates = geometry.getCoordinates();
        return Math.round(coordinates[0] * 1000) / 1000 + ' \n ' + Math.round(coordinates[1] * 1000) / 1000;
    }

    _formatCircleArea(feature, circle) {
        let area = this._measureCircleArea(circle);

        return Math.round(area * 100) / 100 + ' m\xB2';
    }

    _addSelectionLayer() {
        this.layerAdded = true;
        this.mapControl.addTemporaryVectorLayer({
            name: layerTypes.SELECTION,
            geometryType: geomTypes.GEOM_ALL,
            srid: this.mapControl.generalSettingsHandler.settings.ProjCode,
            geomField: 'geom',
            idField: 'id',
            visible: true,
            displayName: this.resourcesHandler.get('SelectionResults'),
            ignoreStyle: true,
            addToLegend: false,
            parentId: layerTypes.INTERACTION_TOOLS,
            parentDisplayName: this.resourcesHandler.get('UserInteractionResults'),
            showLegend: false,
            declutter: false
        });
    }

    _removeInteraction() {
        if (this.currentInteraction != null) {
            this.mapControl.map.removeInteraction(this.currentInteraction);
            this.currentInteraction = null;
        }

        $event.notify(eventTypes.STOP_SNAP, {}, this, this.mapControl.classId);

        this.deleteEnabled = false;
    }

    _initDrawStyle() {
        this.drawMeasureStyle = new Style({
            fill: new Fill({
                color: 'rgba(255, 0, 0, 1)',
            }),
            stroke: new Stroke({
                color: 'rgba(51, 153, 204, 1)',
                width: 3,
            }),
            image: new RegularShape({
                radius: 8,
                radius2: 1,
                points: 4,
                angle: 0,
                stroke: new Stroke({
                    color: 'rgba(255, 0, 0, 1)',
                }),
                fill: new Fill({
                    color: 'rgba(255, 0, 0, 1)',
                }),
            }),
        });

        this.drawLabelStyle = new Style({
            text: new Text({
                font: 'bold 16px Calibri,sans-serif',
                fill: new Fill({
                    color: 'rgba(0, 0, 0, 1)',
                }),
                backgroundFill: new Fill({
                    color: 'rgba(0, 0, 0, 0)',
                }),
                padding: [3, 3, 3, 3],
                textBaseline: 'bottom',
                offsetY: -10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 255, 1)',
                    width: 2,
                })
            })
        });
    }

    _getDrawToolbarVisibleHandler() {
        return () => {
            $(this.menuContainer).find(".selection-point").click();
            this.mapControl.selectionHandler.isActive = false;
            $(this.menuContainer).find(".toolbar-selection").hide();
        };
    }

    _getDrawToolbarHiddenHandler() {
        return () => {
            $(this.menuContainer).find(".toolbar-selection").show();
        };
    }

    _getSelectByPointHandler() {
        return () => {
            $(this.menuContainer).find(".map-toolbar-item").removeClass('active');
            $(this.menuContainer).find(".selection-point").addClass('active');
            this.additionalSettingsVisible = false;
            $(this.menuContainer).find(".map-toolbar-selection-options").hide();
            this.mapControl.selectionHandler.isActive = true;
            this._removeInteraction();
        };
    }

    _getSelectByCircleHandler() {
        return () => {
            $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);
            $(this.menuContainer).find(".map-toolbar-item").removeClass('active');
            $(this.menuContainer).find(".map-toolbar-selection-list").removeClass('joined');
            $(this.menuContainer).find(".selection-circle").addClass('active');
            this.additionalSettingsVisible = false;
            $(this.menuContainer).find(".map-toolbar-selection-options").hide();

            this.mapControl.selectionHandler.isActive = false;
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this._selectByCircle();
        };
    }

    _getUserMapRightClickHandler() {
        var handler = (eventName, data, sender) => {
            if (this.currentInteraction != null) {
                this.currentInteraction.abortDrawing();
                data.originalEvent.preventDefault();
                this.currentInteractionSuspended = true;
                this._removeInteraction();

                if ($(this.menuContainer).find('.map-toolbar-item.active').length > 0) {
                    let item = $($(this.menuContainer).find('.map-toolbar-item.active')[0]);
                    item.removeClass('active');
                    item.click();
                }
            }
        };

        return handler;
    }

    _selectByCircle() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource(),
            type: 'Circle',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Circle');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource().removeFeature(evt.feature);
            } else {
                setTimeout(() => {
                    this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource().clear();
                    $(this.menuContainer).find(".selection-point").click();
                    this.mapControl.selectionHandler.isActive = false;
                }, 25);

                setTimeout(() => {
                    this.mapControl.selectionHandler.isActive = true;
                    this.mapControl.map.getViewport().style.cursor = 'inherit';
                }, 500);

                this.mapControl.selectionHandler.selectByFeature(evt.feature);
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Circle' }, this, this.mapControl.classId);
    }

    _getSelectByLineHandler() {
        return () => {
            $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);
            $(this.menuContainer).find(".map-toolbar-item").removeClass('active');
            $(this.menuContainer).find(".map-toolbar-selection-list").removeClass('joined');
            $(this.menuContainer).find(".selection-line").addClass('active');
            this.additionalSettingsVisible = false;
            $(this.menuContainer).find(".map-toolbar-selection-options").hide();

            this.mapControl.selectionHandler.isActive = false;
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this._selectByLine();
        };
    }

    _selectByLine() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource(),
            type: 'LineString',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'LineString');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource().removeFeature(evt.feature);
            } else {
                setTimeout(() => {
                    this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource().clear();
                    $(this.menuContainer).find(".selection-point").click();
                    this.mapControl.selectionHandler.isActive = false;
                }, 25);

                setTimeout(() => {
                    this.mapControl.selectionHandler.isActive = true;
                    this.mapControl.map.getViewport().style.cursor = 'inherit';
                }, 500);

                this.mapControl.selectionHandler.selectByFeature(evt.feature);
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'LineString' }, this, this.mapControl.classId);
    }

    _getSelectByRectangleHandler() {
        return () => {
            $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);
            $(this.menuContainer).find(".map-toolbar-item").removeClass('active');
            $(this.menuContainer).find(".map-toolbar-selection-list").removeClass('joined');
            $(this.menuContainer).find(".selection-rectangle").addClass('active');
            this.additionalSettingsVisible = false;
            $(this.menuContainer).find(".map-toolbar-selection-options").hide();

            this.mapControl.selectionHandler.isActive = false;
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this._selectByRectangle();
        };
    }

    _selectByRectangle() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource(),
            type: 'Circle',
            geometryFunction: createBox(),
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Polygon');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource().removeFeature(evt.feature);
            } else {
                setTimeout(() => {
                    this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource().clear();
                    $(this.menuContainer).find(".selection-point").click();
                    this.mapControl.selectionHandler.isActive = false;
                }, 25);

                setTimeout(() => {
                    this.mapControl.selectionHandler.isActive = true;
                    this.mapControl.map.getViewport().style.cursor = 'inherit';
                }, 500);

                this.mapControl.selectionHandler.selectByFeature(evt.feature);
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Polygon' }, this, this.mapControl.classId);
    }

    _getSelectByPolygonHandler() {
        return () => {
            $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);
            $(this.menuContainer).find(".map-toolbar-item").removeClass('active');
            $(this.menuContainer).find(".map-toolbar-selection-list").removeClass('joined');
            $(this.menuContainer).find(".selection-polygon").addClass('active');
            this.additionalSettingsVisible = false;
            $(this.menuContainer).find(".map-toolbar-selection-options").hide();

            this.mapControl.selectionHandler.isActive = false;
            this.mapControl.map.getViewport().style.cursor = 'crosshair';
            this._selectByPolygon();
        };
    }

    _selectByPolygon() {
        this._removeInteraction();
        this.currentInteraction = new Draw({
            source: this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource(),
            type: 'Polygon',
            style: (feature) => {
                return this._drawStyleFunction(feature, 'Polygon');
            },
            condition: primaryAction,
            finishCondition: primaryAction
        });

        this.currentInteraction.on('drawend', (evt) => {
            if (this.currentInteractionSuspended) {
                this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource().removeFeature(evt.feature);
            } else {
                setTimeout(() => {
                    this.mapControl.layerHandler.getLayerById(layerTypes.SELECTION)[0].getSource().clear();
                    $(this.menuContainer).find(".selection-point").click();
                    this.mapControl.selectionHandler.isActive = false;
                }, 25);

                setTimeout(() => {
                    this.mapControl.selectionHandler.isActive = true;
                    this.mapControl.map.getViewport().style.cursor = 'inherit';
                }, 500);

                this.mapControl.selectionHandler.selectByFeature(evt.feature);
            }
        });

        this.currentInteractionSuspended = false;
        this.mapControl.map.addInteraction(this.currentInteraction);
        $event.notify(eventTypes.START_SNAP, { geomType: 'Polygon' }, this, this.mapControl.classId);
    }

    // Butonul "selectează folosind selecția" e activ doar cât timp există o
    // selecție pe hartă; la deselectare se dezactivează.
    _getFeatureSelectionChangedHandler() {
        return () => {
            let hasSelection = this.mapControl.selectionHandler.getAllMapSelectedFeatures().length > 0;
            let item = $(this.menuContainer).find(".selection-selected");

            if (hasSelection) {
                item.removeClass('disabled');
            } else {
                item.addClass('disabled').removeClass('active');
            }
        };
    }

    _getSelectBySelectedHandler() {
        return () => {
            let item = $(this.menuContainer).find(".selection-selected");
            if (item.hasClass('disabled')) {
                return;
            }

            $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);
            $(this.menuContainer).find(".map-toolbar-item").removeClass('active');
            $(this.menuContainer).find(".map-toolbar-selection-list").removeClass('joined');
            this.additionalSettingsVisible = false;
            $(this.menuContainer).find(".map-toolbar-selection-options").hide();

            this._removeInteraction();
            this.mapControl.map.getViewport().style.cursor = 'inherit';

            // Geometria selecției curente devine input; entitatea-sursă se
            // deselectează în interiorul metodei, apoi butonul se dezactivează
            // singur prin evenimentul de selecție.
            this.mapControl.selectionHandler.selectByCurrentSelection();

            $(this.menuContainer).find(".selection-point").addClass('active');
            this.mapControl.selectionHandler.isActive = true;
        };
    }

    _getSelectionOptionsHandler() {
        return () => {
            $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);
            $(this.menuContainer).find(".map-toolbar-item").removeClass('active');
            $(this.menuContainer).find(".map-toolbar-selection-list").removeClass('joined');
            $(this.menuContainer).find(".selection-options").addClass('active');

            if (this.additionalSettingsVisible) {
                this.additionalSettingsVisible = false;
                $(this.menuContainer).find(".map-toolbar-selection-options").hide();
                $(this.menuContainer).find(".selection-options").removeClass('active');
            } else { 
                this.additionalSettingsVisible = true;
                $(this.menuContainer).find(".map-toolbar-selection-options").show();
                $(this.menuContainer).find(".map-toolbar-selection-list").addClass('joined');
            }
        };
    }

    _getClearSelectionHandler() {
        return () => {
            $event.notify(eventTypes.CLEAR_MULTIPLE_SELECTION, {}, this, this.classId);
            $('.map-toolbar-item.clear-selection').hide();
        };
    }

    //CG: masuram in proiectia curenta a hartii, nu in Web Mercator implicit din ol/sphere
    _measureLength(geometry) {
        return measureLength(geometry, this.mapControl.map.getView().getProjection());
    }

    _measureCircleArea(circle) {
        return measureCircleArea(circle, this.mapControl.map.getView().getProjection());
    }

    _measureArea(geometry) {
        return measureArea(geometry, this.mapControl.map.getView().getProjection());
    }

    _formatLength(feature, length) {
        return Math.round(length * 100) / 100 + ' m';
    }

    _formatAngle(feature, geometry) {
        return Math.round(this._getRotation(geometry) * 1000) / 1000 + ' °';
    }

    _getRotation(geometry) {
        let coords = geometry.getCoordinates();

        let first = coords[0];
        let last = coords[1];
        let rotation = -Math.atan2((last[1] - first[1]), (last[0] - first[0]));
        rotation = rotation * (180 / Math.PI);

        if (rotation < 0) {
            rotation = 360 + rotation;
        }

        rotation += 90;

        if (rotation > 360) {
            rotation -= 360;
        }

        return rotation;
    }

    _formatArea(feature, polygon) {
        let area = this._measureArea(polygon);
        return Math.round((area / 1000000) * 100) / 100 + ' km\xB2';
    }
}